/* eslint-disable */

// NOTE: We've migrated from react-universal-component to @loadable/component for React 18 compatibility
// The previous implementation had issues with page flickering due to webpack module resolution conflicts
// @loadable/component provides better code splitting and SSR support for React 18
// require('@loadable/component');
// require('@loadable/server');

require('@babel/polyfill');
require('classnames');
require('classnames/bind');
require('es6-symbol/implement');
require('extend');
require('fetch-jsonp');
require('fontfaceobserver'); // Layout component uses FontLoader.jsx
require('history'); // used by yoda-app-shell/lib/client.jsx
require('isomorphic-fetch');
require('lodash/capitalize');
require('lodash/cloneDeep');
require('lodash/compact');
require('lodash/debounce');
require('lodash/defer');
require('lodash/each');
require('lodash/extend');
require('lodash/filter');
require('lodash/find');
require('lodash/findIndex');
require('lodash/flatten');
require('lodash/get');
require('lodash/has');
require('lodash/includes');
require('lodash/indexOf');
require('lodash/intersection');
require('lodash/isEmpty');
require('lodash/isEqual');
require('lodash/map');
require('lodash/merge');
require('lodash/noop');
require('lodash/omit');
require('lodash/take');
require('lodash/uniqueId');
require('lodash/values');
require('no-scroll'); // used by YodaFooter - ModalBox - ScrollLockHOC
require('qs');
require('react');
require('react');
require('react-circular-progressbar'); // React circular progress used in Header Account hover
require('react-dom');
require('react-fastclick-alt'); // CheckBox yoda-core-components that is used by FindAStorePage and ProductCard
require('react-redux');
require('react-router-dom');
require('redux');
require('redux-saga/effects');
require('reselect');
